<template>
  <section class="stats-section">
    <h2 class="section-title">Powered by Data & AI</h2>
    <div class="stats-grid">
      <div v-for="(stat, index) in stats" :key="index" class="stat-card" ref="statCards">
        <!-- 4. Initialize values in template -->
        <div class="stat-number">
          <span 
            :id="'stat' + (index + 1)" 
            :data-initial-value="stat.value"
          >{{ stat.value }}</span>{{ stat.suffix }}
        </div>
        <div class="stat-label">{{ stat.label }}</div>
      </div>
    </div>

    <div class="algorithms" ref="algorithms">
      <h3>Advanced AI Algorithms</h3>
      <div class="algo-tags">
        <div v-for="(algo, index) in algorithms" :key="index" class="algo-tag">{{ algo }}</div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      stats: [
        { value: 1500, suffix: "M+", label: "Molecular Structures" },
        { value: 20, suffix: "K+", label: "Targets" },
        { value: 2000, suffix: "M+", label: "BioMedical Texts" }
      ],
      algorithms: [
        "Large Language Models", "Transfer Learning", "Reinforcement Learning",
        "Generative Adversarial Networks", "Graph Neural Networks", "Diffusion Model",
        "Molecular Dynamics", "Quantum Computing"
      ]
    };
  },
  mounted() {
    this.setupScrollAnimations();
    this.fetchStats();
  },
  methods: {
    async fetchStats() {
      try {
        const response = await axios.get('/stats');
        this.stats = [
        { value: response.data.targets, suffix: "K+", label: "Targets" },
          { value: response.data.molecules, suffix: "M+", label: "Molecules" },
          { value: response.data.texts, suffix: "M+", label: "BioMedical Texts" }
        ];
      } catch (error) {
        console.error('Error fetching stats:', error);
        // Fallback to initial values
        this.stats = [
          { value: 1500, suffix: "M+", label: "Molecules" },
          { value: 20, suffix: "K+", label: "Targets" },
          { value: 2000, suffix: "M+", label: "BioMedical Texts" }
        ];
      }
    },
    setupScrollAnimations() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            if (entry.target.classList.contains('stat-card') && !entry.target.dataset.animated) {
              const span = entry.target.querySelector('.stat-number span');
              if (span) {
                this.animateStatValue(span);
              }
              entry.target.dataset.animated = true;
            }
          }
        });
      }, { threshold: 0.15 });

      this.$refs.statCards?.forEach(card => {
        observer.observe(card);
      });
      
      if (this.$refs.algorithms) {
        observer.observe(this.$refs.algorithms);
      }
    },
    // 3. Improved animation method
    animateStatValue(element) {
      if (!element) return;
      
      // Get target value from dataset
      const targetValue = parseInt(element.dataset.initialValue || element.textContent);
      
      // Ensure we have a valid number
      if (isNaN(targetValue)) return;
      
      let currentValue = 0;
      const duration = 2000;
      const increment = targetValue / (duration / 16);

      // Clear any existing animation
      if (element.animationInterval) {
        clearInterval(element.animationInterval);
      }

      element.animationInterval = setInterval(() => {
        currentValue += increment;
        if (currentValue >= targetValue) {
          currentValue = targetValue;
          clearInterval(element.animationInterval);
        }
        element.textContent = Math.round(currentValue);
      }, 16);
    }
  }
};
</script>